import DownloadButtonForTable from './DownloadButtonForTable';

export default DownloadButtonForTable;
